export default __webpack_public_path__ + "static/Laptop_meeting-47f9de95e2f7260a58ecef9fb8eaa95a.png";